// Extra languages for prism-react-renderer, which only bundles a subset of Prism's.
// See https://github.com/FormidableLabs/prism-react-renderer#custom-language-support
import { Prism } from 'prism-react-renderer'

// Prism language components register themselves on the global `Prism` object.
globalThis.Prism = Prism
require('prismjs/components/prism-haskell')
require('prismjs/components/prism-coq')

// Lean 4: Prism has no grammar for it, so we start from Haskell (similar comments,
// imports, operators...) and add Lean's own keywords, tactics and commands.
Prism.languages.lean = Prism.languages.extend('haskell', {
  comment: [
    { pattern: /\/-[\s\S]*?-\//, greedy: true },
    { pattern: /--.*/, greedy: true },
  ],
  keyword: /\b(?:abbrev|at|axiom|by|calc|class|def|deriving|do|else|end|example|exists|extends|fun|have|if|in|inductive|instance|lemma|let|match|mutual|namespace|noncomputable|open|partial|private|protected|return|section|show|structure|suffices|then|theorem|universe|variable|where|with|Prop|Sort|Type)\b|[λ∀∃]/,
})
delete Prism.languages.lean.builtin

Prism.languages.insertBefore('lean', 'keyword', {
  command: { pattern: /#(?:check|eval|print|reduce)\b/, alias: 'keyword' },
})

Prism.languages.insertBefore('lean', 'hvariable', {
  tactic: {
    pattern: /\b(?:apply|assumption|by_cases|cases|constructor|contradiction|decide|exact|exfalso|existsi|ext|intro|intros|induction|linarith|nlinarith|norm_num|omega|positivity|rcases|refine|rfl|ring|rintro|rw|simp|simp_all|sorry|specialize|trivial|unfold|use)\b/,
    alias: 'function-variable',
  },
})
